module.exports = __webpack_public_path__ + "static/img/honor.5cc93461.png";